export const scope = "ModalManagement";

const CreateModalManagementStore = (set) => ({
  content: null,
  modalProps: {},

  setValue: (key, value) => {
    set(
      (currentState) => ({
        ...currentState,
        [scope]: { ...currentState[scope], [key]: value },
      }),
      false,
      `${scope} : setValue: ${key}`,
    );
  },

  setContent: (children) => {
    set(
      (store) => {
        store[scope].content = children;
        return store;
      },
      false,
      `${scope} : setContent`,
    );
  },
});

export default CreateModalManagementStore;
